import { createSlice } from '@reduxjs/toolkit';
import { getActiveCheckautoList } from '../active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activeCheckauto';

export const activeCheckautoSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActiveCheckautoList });
    },
});

export const selectActiveCheckauto = (state) => state.activeCheckauto.data;

export const activeCheckauto = activeCheckautoSlice.reducer;
